// extracted by mini-css-extract-plugin
export default {"button":"button-2kCZsb","icon":"icon-1NK1oT"};